export const VERISK_URL = `${process.env.NEXT_PUBLIC_VERISK_BASE_URL}/api/v1`;
export const VERISK_KEY = `${process.env.NEXT_PUBLIC_VERISK_BFF_API_KEY}`;
export const DOMAIN_KEY = `${process.env.NEXT_PUBLIC_DOMAIN_KEY || ""}`;
